<script setup>
const WrTextAsImage = defineAsyncComponent(() => import("./WrTextAsImage.vue"));

const selectedIndex = ref(-1);

const companyAddresses = ref([
  {
    country: "USA Office",
    icon: "/images/USAicon.webp",
    darkIcon: "/images/darkModeUSAImg.webp",
    companyAddress: "7858, 1021 E Lincolnway, Cheyenne, WY, Laramie, US, 82001",
    contactNo: [{ text: "+1 585 215 1444 ", linkContactNo: "+15852151444" }],
    whatsAppNo: [{ text: "+1 585 215 1444", linkWhatAppNo: "+15852151444" }],
    mail: "we@webreinvent.com",
    altText: "WebReinvent Location Icon",
  },
  {
    country: "India Office",
    icon: "/images/INDIAicon.webp",
    darkIcon: "/images/darkModeINDImg.webp",
    companyAddress:
      "Unit 606, 6th Floor, Tower 2 Capital Business Park, Sector 48, Gurugram, Haryana, India 122018",
    contactNo: [
      {
        text: "+91 858 886 4948 /",
        linkContactNo: "+918588864948",
      },
      { text: "+91 794 344 4427", linkContactNo: "+012003134356" },
    ],
    mail: "we@webreinvent.com",
    altText: "WebReinvent Location Icon",
  },
]);

const visible = ref(false);

const handleOpen = () => {
  visible.value = true;
};
</script>
<template>
  <template v-for="(address, index) in companyAddresses" :key="address.country">
    <div
      class="md:max-w-[667px] w-full p-px dark:bg-[linear-gradient(91.95deg,rgba(98,69,116,0.7)_4.5%,rgba(122,84,157,0.7)_96.91%)] bg-[linear-gradient(91.95deg,rgba(242,242,242,0.7)_4.5%,rgba(204,204,204,0.7)_96.91%)] rounded-xl"
    >
      <div
        class="flex gap-8 items-center md:justify-center bg-[image:var(--bg-official-partner)] lg:py-10 py-4 lg:pl-12 pl-4 lg:pr-24 pr-10 rounded-xl h-full shadow-[3px_23px_52px_-2px_rgba(0,0,0,0.05)]"
      >
        <NuxtImg
          alt="Address Icon"
          :src="
            $colorMode.preference == 'dark' ? address.darkIcon : address.icon
          "
          class="shrink-0"
          height="112"
          width="83"
          loading="lazy"
          format="webp"
        />
        <div class="flex flex-col">
          <h3 class="text-xl font-semibold">{{ address.country }}</h3>
          <div class="mt-[26px]">
            <p class="text-base tracking-[0.5px]">
              {{ address.companyAddress }}
            </p>
            <div class="text-base font-semibold mt-3 flex gap-2">
              <div
                v-if="address.whatsAppNo"
                class="max-sm:flex max-sm:flex-col flex sm:items-center sm:gap-1"
              >
                <a
                  v-for="(whatsAppNo, index) in address.whatsAppNo"
                  class="hover:underline flex items-center gap-1"
                  :href="`https://wa.me/${whatsAppNo.linkWhatAppNo}`"
                >
                  <!-- <WhatsAppIconDark /> -->
                  <WrSVGIcon name="WhatsAppIconDark" class="size-[21px]" />
                  {{ whatsAppNo.text }}</a
                >
                <p>(Sales)</p>
              </div>
              <div
                v-else
                class="max-sm:flex max-sm:flex-col flex sm:items-center sm:gap-1"
              >
                <a
                  v-for="contactNo in address.contactNo"
                  class="hover:underline"
                  :href="`tel:${contactNo.linkContactNo}`"
                  >{{ contactNo.text }}
                </a>

                <p>(HR / Admin)</p>
              </div>
            </div>
            <p class="mt-1 font-semibold tracking-[0.5px] relative">
              <span @click="handleOpen()" class="hover:cursor-pointer">
                <WrTextAsImage />
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>
  <WrContactFormPopup :isOpen="visible" @close="visible = false" class="z-30" />
</template>
